// types
import { Financier, Loan } from '../../../@types';

// ui
import { financierIconTypes, IconCircle, IconCircleProps } from '../IconCircle/IconCircle';

// discriminated union for props
type IconCircleLoanPropsWithLoan = {
	loan: Loan;
	financier?: never;
} & IconCircleProps;

type IconCircleLoanPropsWithFinancier = {
	loan?: never;
	financier: Financier;
} & IconCircleProps;

export type IconCircleLoanProps = IconCircleLoanPropsWithLoan | IconCircleLoanPropsWithFinancier;

export const IconCircleLoan = ({ financier, loan, ...props }: IconCircleLoanProps) => {
	// Determine the financier from either the loan or the direct financier prop
	const loanFinancier = loan?.financier || financier;

	// Default props
	const iconCircleProps: IconCircleProps = {
		TooltipProps: {
			title: loanFinancier,
		},
		type: loanFinancier ? financierIconTypes[loanFinancier] : 'loan',
		...props,
	};

	return <IconCircle {...iconCircleProps} />;
};
